module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns-house_access_07-3b6a03c909529559fecbf61ae49afb7a.jpg";